import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { formatDate } from '@buyside/util/dateHelper';

import { Asset, Idea, Maybe, Position } from '@interfaces/graphql-typings';

import styles from '@buyside/components/presentation/ContributorDashboard/contributorDashboardStyles.scss';

const viewCount = (count: number): React.ReactElement => (
  <span className={styles.viewCount}>
    <strong>{count}</strong> new
  </span>
);

const MyIdeasNav: React.FC<{
  ideaId?: string;
  ideas: Array<
    Maybe<{
      node?: Maybe<
        Pick<Idea, 'id' | 'createdAt' | 'newViewsCount'> & {
          positions: Array<
            Pick<Position, 'id'> & { asset?: Maybe<Pick<Asset, 'id' | 'primarySymbol'>> }
          >;
        }
      >;
    }>
  >;
}> = ({ ideaId, ideas }) => {
  return (
    <div className={styles.ideaList}>
      <Link
        className={classnames(styles.ideaItem, {
          [styles.selected]: !ideaId
        })}
        to="/ideas"
      >
        All ideas
        {viewCount(ideas.reduce((acc, edge) => acc + (edge?.node?.newViewsCount || 0), 0))}
      </Link>
      {ideas.map(
        edge =>
          edge?.node && (
            <Link
              className={classnames(styles.ideaItem, {
                [styles.selected]: ideaId === edge.node.id
              })}
              key={edge.node.id}
              to={`/ideas/${edge.node.id}`}
            >
              <div>
                {edge.node.positions.map(position => position.asset?.primarySymbol)}
                <div className={styles.ideaDate}> ({formatDate(edge.node.createdAt)})</div>
              </div>
              {viewCount(edge.node.newViewsCount)}
            </Link>
          )
      )}
    </div>
  );
};

export default MyIdeasNav;
